// Table Config Imports
import {
    table_config_compact_38,
    table_config_compact_somatic,
} from "../../../../../../../../config-files/table-config/snv-table/table_config";

// Utility function to check if a field should be visible based on table config and instand setting
export const isFieldVisible = (fieldId, somatic) => {
    // If not in instand mode, show all fields
    if (!window.config.field_filtering) {
        return true;
    }

    // Get the appropriate table config based on somatic setting
    let table_config;
    if (somatic) {
        table_config = table_config_compact_somatic;
    } else {
        table_config = table_config_compact_38; // default to compact_38 for germline
    }

    // Find the field in the table config
    for (let mainH of table_config) {
        for (let subheading of mainH.subheadings) {
            if (subheading.id === fieldId) {
                return subheading.visible !== false;
            }
        }
    }

    // If field not found in config, show it by default
    return true;
};
